import vueWeekTimeRangePicker from "./views/index.vue";

export default vueWeekTimeRangePicker;
